/* Build Your Set - gown picker + rail (the "Comfort at the best prices" segment).
   Standalone like extras.js: uses window.BYS money/esc helpers when present,
   announces cart changes via 'cart:updated' and listens for the same event so
   the set builder's adds keep this rail honest. All hooks are data-gp-*.
   The ladder here is display only; the parked automatic discounts are the money.
   2026-09-25 (NightCool nightgowns): tiers can be dollars off EACH gown ([data-gp-tiers] data-gp-unit="each"),
   the root can carry per-handle display names (data-gp-names JSON), and relative calls add _fd=0 on the
   *.myshopify.com preview host only, where they otherwise redirect to www and die. Percent ladders
   (DayBasics) paint exactly the words they did before.
   2026-10-01: a benefits card under the size row ([data-gp-benefits], copy from the block). On a band carrying
   data-gp-tidy (the dollars-each one) the rail tidies up after an add the way the set builder's does (the gown
   just added stops counting as a fresh pick and the rail reads "Added."), and the rung tiles celebrate. */
(function () {

  function init(root) {
    if (root.getAttribute('data-gp-ready') === '1') return;
    root.setAttribute('data-gp-ready', '1');
    var BYS = window.BYS || {};
    var money = BYS.money || function (c) { return '$' + (c / 100).toFixed(2); };
    var esc = BYS.esc || function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

    var styleSel = root.querySelector('[data-gp-style]');
    var optsEl = root.querySelector('[data-gp-options]');
    var mediaEl = root.querySelector('[data-gp-media]');
    var priceTag = root.querySelector('[data-gp-pricetag]');
    var stateEl = root.querySelector('[data-gp-state]');
    var slotsEl = root.querySelector('[data-gp-slots]');
    var fullEl = root.querySelector('[data-gp-fullprice]');
    var payEl = root.querySelector('[data-gp-payprice]');
    var noteEl = root.querySelector('[data-gp-savenote]');
    var addBtn = root.querySelector('[data-gp-add]');
    var addedEl = root.querySelector('[data-gp-added]');
    var errEl = root.querySelector('[data-gp-error]');
    var tiersEl = root.querySelector('[data-gp-tiers]');
    var progEl = root.querySelector('[data-gp-prog]');
    var mileEl = root.querySelector('[data-gp-mile]');
    if (!styleSel || !optsEl || !addBtn) return;

    var addLabel = addBtn.textContent;
    var trim = root.getAttribute('data-gp-trim') || '';
    var names = {};
    try { names = JSON.parse(root.getAttribute('data-gp-names') || '{}') || {}; } catch (e) {}
    var FD = /\.myshopify\.com$/.test(location.hostname);
    function u(p) { return FD ? p + (p.indexOf('?') > -1 ? '&' : '?') + '_fd=0' : p; }
    var tidy = root.hasAttribute('data-gp-tidy');
    var benEl = root.querySelector('[data-gp-benefits]');
    var benData = null;
    try { benData = JSON.parse((root.querySelector('[data-gp-benefits-data]') || {}).textContent || 'null'); } catch (e) {}
    var lastAdded = null;   /* variant id just added: not a fresh pick until the shopper changes something */
    var pendingAdded = null;
    var swatchMaps = {};
    try { swatchMaps = JSON.parse((root.querySelector('[data-gp-swatches]') || {}).textContent || '{}'); } catch (e) {}

    var handles = [].slice.call(styleSel.options).map(function (o) { return o.value; }).filter(Boolean);
    var tiers = tiersEl ? [].slice.call(tiersEl.children).map(function (el) {
      return { el: el, q: parseInt(el.getAttribute('data-q'), 10) || 0, pct: parseFloat(el.getAttribute('data-amt')) || 0 };
    }).filter(function (t) { return t.q > 0; }) : [];
    var maxQ = tiers.length ? tiers[tiers.length - 1].q : 0;
    var each = !!(tiersEl && tiersEl.getAttribute('data-gp-unit') === 'each');
    /* the words for one rung: "15% off" (percent ladder) or "$5 off each" (dollars each) */
    function rungTxt(v) { return each ? '$' + v + ' off each' : v + '% off'; }
    /* data-gp-max (Sandra 2026-10-16): no per-gown steps, only the highest saving */
    var MAXTXT = tiersEl ? (tiersEl.getAttribute('data-gp-max') || '') : '';
    /* data-gp-credit (Sandra 2026-10-29): gowns earn store credit. Checkout takes nothing off, so the full price shows and
       the credit sits beside it as a badge, where the struck price sat. */
    var CREDIT = root.hasAttribute('data-gp-credit');
    var creditEl = root.querySelector('[data-gp-credit-badge]');

    var product = null, sel = [], cache = {};
    var cartLines = [], cartCount = 0;

    function trimName(t, h) {
      if (h && names[h]) return names[h];
      t = String(t || '');
      if (trim && t.indexOf(trim + ' ') === 0) { var r = t.slice(trim.length).replace(/^\s+/, ''); if (r) return r; }
      return t;
    }
    function match() {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function tierPct(n) {
      var a = 0;
      tiers.forEach(function (t) { if (t.q <= n) a = t.pct; });
      return a;
    }
    /* Percent ladder: the dollars off are the tier percentage of the gowns in play. */
    var fullNow = 0;
    function tierAmt(n) { return each ? Math.round(tierPct(n) * 100) * n : Math.round(fullNow * tierPct(n) / 100); }
    function thumb(src) {
      return String(src).replace(/(\.[a-z]+)(\?|$)/i, '_160x160_crop_center$1$2');
    }
    /* Compare-at aware price. Sandra's permanent 30% DayBasics markdown sets
       compare_at_price on every variant, so this lights up on its own the moment
       the Matrixify reprice lands; before that it renders the plain price. */
    function priceHTML(v) {
      if (!v) return '';
      var was = v.compare_at_price || 0;
      return (was > v.price ? '<s>' + money(was) + '</s> ' : '') + money(v.price);
    }

    function paintBenefits() {
      if (!benEl || !benData || !product) return;
      var tag = (benData.of || {})[product.handle], d = null;
      (benData.lines || []).forEach(function (l) { if (l.tag === tag) d = l; });
      if (!d) { benEl.hidden = true; return; }
      var c = /^#[0-9a-f]{3,8}$/i.test(d.color || '') ? d.color : '#2c3d54';
      var pts = String(d.pts || '').split(';').map(function (p) { return p.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
      benEl.style.setProperty('--gben', c);
      benEl.innerHTML = '<div class="bys__gben-h"><b>' + esc(d.name || '') + '</b>' + (d.sub ? '<span>' + esc(d.sub) + '</span>' : '') + '</div>' +
        (pts.length ? '<ul>' + pts.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>' : '') +
        (d.foot ? '<div class="bys__gben-f">' + esc(d.foot) + '</div>' : '');
      benEl.hidden = false;
    }

    /* Celebration, tidy bands only. A rung won: its tile bounces, throws sparks and the rail gets confetti.
       No new rung: the next tile leans in, to show what one more gown unlocks. */
    function sparks(el) {
      var box = document.createElement('span'); box.className = 'bys__gspark'; box.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 12; i++) {
        var s = document.createElement('i'), a = (Math.PI * 2 * i) / 12, d = 26 + Math.random() * 22;
        s.style.setProperty('--dx', Math.round(Math.cos(a) * d) + 'px'); s.style.setProperty('--dy', Math.round(Math.sin(a) * d) + 'px');
        s.style.background = ['#eca49e', '#f4c3b1', '#f7f5ef', '#637ea1'][i % 4];
        box.appendChild(s);
      }
      el.appendChild(box);
      setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 900);
    }
    function confetti(host) {
      if (!host) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      if (BYS.confetti) { BYS.confetti(host, 32); return; }
      var colors = ['#eca49e', '#f4c3b1', '#637ea1', '#2c3d54', '#f7f5ef'], box = document.createElement('div');
      box.className = 'bys__confetti';
      for (var i = 0; i < 32; i++) {
        var s = document.createElement('span');
        s.style.left = (Math.random() * 100) + '%'; s.style.background = colors[i % colors.length];
        s.style.animationDelay = (Math.random() * 0.25) + 's'; s.style.transform = 'rotate(' + Math.floor(Math.random() * 360) + 'deg)';
        box.appendChild(s);
      }
      host.appendChild(box);
      setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 1800);
    }
    function flash(el, cls, ms) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, ms); }
    function celebrate(prev) {
      if (!tidy || !tiers.length || cartCount <= prev) return;
      var won = null, next = null;
      tiers.forEach(function (t) { if (t.q <= cartCount) won = t; else if (!next) next = t; });
      if (won && tierPct(cartCount) > tierPct(prev)) {
        flash(won.el, 'is-hit', 900); sparks(won.el); confetti(root.querySelector('.bys__grail'));
      } else if (next) {
        flash(next.el, 'is-nudge', 900);
      } else if (won) {
        flash(won.el, 'is-hit', 900);
      }
    }

    /* What a gown in the cart cost before any markdown: its compare-at price, read from the style's product data
       (the cart only knows the selling price). The pick is priced the same way, so the struck total never mixes the two. */
    function lineWas(it) {
      var p = cache[it.handle], was = it.original_price > it.price ? it.original_price : it.price;
      if (p) { for (var i = 0; i < p.variants.length; i++) { var v = p.variants[i]; if (v.id === (it.variant_id || it.id)) { if ((v.compare_at_price || 0) > was) was = v.compare_at_price; break; } } }
      return was;
    }
    function learnCartStyles() {
      cartLines.forEach(function (it) {
        if (cache[it.handle] || cache[it.handle] === 0) return;
        cache[it.handle] = 0;   /* asked, not here yet */
        fetch(u('/products/' + it.handle + '.js'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (p) { cache[it.handle] = p; paintRail(); })
          .catch(function () { delete cache[it.handle]; });
      });
    }

    function paintOptions() {
      var swatches = (product && swatchMaps[product.handle]) || {};
      var html = '';
      var names = (product.options || []).map(function (o) { return (o && o.name) ? o.name : o; });
      names.forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (v) { if (values.indexOf(v.options[i]) < 0) values.push(v.options[i]); });
        var isColor = /colou?r/i.test(String(name));
        html += '<div class="bys__gopt-l">' + esc(name) + ' &middot; <b>' + esc(sel[i] || '') + '</b></div>';
        html += '<div class="bys__qa-row" data-gp-i="' + i + '">';
        values.forEach(function (val) {
          var avail = product.variants.some(function (v) { return v.options[i] === val && v.available; });
          var state = (sel[i] === val ? ' aria-pressed="true"' : '') + (avail ? '' : ' disabled');
          var hex = isColor ? swatches[val] : null;
          if (hex) {
            html += '<button type="button" class="bys__qa-sw" data-gp-val="' + esc(val) + '" style="--sw:' + esc(hex) + '"' +
              ' title="' + esc(val) + '" aria-label="' + esc(val) + '"' + state + '></button>';
          } else {
            html += '<button type="button" class="bys__qa-pill" data-gp-val="' + esc(val) + '"' + state + '>' + esc(val) + '</button>';
          }
        });
        html += '</div>';
      });
      optsEl.innerHTML = html;
      [].slice.call(optsEl.querySelectorAll('.bys__qa-pill, .bys__qa-sw')).forEach(function (p) {
        p.addEventListener('click', function () {
          var i = parseInt(p.parentNode.getAttribute('data-gp-i'), 10);
          sel[i] = p.getAttribute('data-gp-val');
          paintOptions(); paintMedia(); paintRail();
        });
      });
    }

    function paintMedia() {
      if (!product) return;
      var m = match();
      var img = (m && m.featured_image && m.featured_image.src) || product.featured_image;
      var v = m || product.variants[0];
      if (img && mediaEl) {
        var badge = mediaEl.querySelector('.bys__cardbadge');
        mediaEl.innerHTML = (badge ? badge.outerHTML : '') +
          '<img src="' + esc(img) + '" alt="' + esc(product.title) + '" width="800" height="1000" loading="lazy">' +
          '<span class="bys__gpricetag">' + priceHTML(v) + '</span>';
        priceTag = mediaEl.querySelector('.bys__gpricetag');
      } else if (priceTag && v) {
        priceTag.innerHTML = priceHTML(v);
      }
    }

    function paintRail() {
      var m = match();
      var avail = m && m.available;
      var justAdded = !!(tidy && m && lastAdded === m.id);
      var live = avail && !justAdded;   /* a fresh pick, counted on top of the cart */
      var withPick = cartCount + (live ? 1 : 0);

      var html = '';
      cartLines.forEach(function (it) {
        html += '<div class="bys__slot is-filled">' +
          '<span class="bys__slot-thumb">' + (it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" width="54" height="54" loading="lazy">' : '') + '</span>' +
          '<span class="bys__slot-t"><b>' + esc(trimName(it.product_title, it.handle)) + '</b>' +
          '<span>' + esc(it.variant_title || '') + ' &middot; ' +
          (lineWas(it) > it.price ? '<s>' + money(lineWas(it)) + '</s> ' : '') + money(it.price) +
          (it.quantity > 1 ? ' &times; ' + it.quantity : '') + '</span></span>' +
          '<span class="bys__gtag">In cart</span></div>';
      });
      if (product && m && !justAdded) {
        var pimg = (m.featured_image && m.featured_image.src) || product.featured_image;
        html += '<div class="bys__slot is-filled">' +
          '<span class="bys__slot-thumb">' + (pimg ? '<img src="' + esc(thumb(pimg)) + '" alt="" width="54" height="54" loading="lazy">' : '') + '</span>' +
          '<span class="bys__slot-t"><b>' + esc(trimName(product.title, product.handle)) + '</b>' +
          '<span>' + (m.options || []).map(esc).join(' &middot; ') + ' &middot; ' + priceHTML(m) + '</span></span>' +
          '<span class="bys__gtag bys__gtag--pick">Your pick</span></div>';
      }
      slotsEl.innerHTML = html;

      var cartTotal = 0, cartWas = 0;
      cartLines.forEach(function (it) {
        cartTotal += it.price * it.quantity;
        cartWas += lineWas(it) * it.quantity;
      });
      var full = cartTotal + (live ? m.price : 0);
      fullNow = full;
      var mWas = live ? ((m.compare_at_price || 0) > m.price ? m.compare_at_price : m.price) : 0;
      var wasTotal = cartWas + mWas;
      var disc = tierAmt(withPick);

      if (creditEl) { creditEl.hidden = !(CREDIT && withPick > 0 && disc > 0); creditEl.textContent = (CREDIT && disc > 0) ? '+' + money(disc).replace(/\.00$/, '') + ' in store credit' : ''; }
      if (withPick === 0) {
        fullEl.hidden = true;
        payEl.textContent = 'Pick your gown';
        noteEl.textContent = '';
      } else {
        var gpay = CREDIT ? full : full - disc;
        if (wasTotal > gpay) {
          fullEl.hidden = false;
          fullEl.textContent = money(wasTotal);
        } else {
          fullEl.hidden = true;
        }
        payEl.textContent = money(gpay);
        if (live && withPick >= 2 && tierPct(withPick) > tierPct(cartCount)) {
          noteEl.innerHTML = MAXTXT ? 'Add it and you save <b>' + money(disc) + '</b>, automatically.' : 'Add it and you unlock <b>' + rungTxt(tierPct(withPick)) + ', ' + money(disc) + ', automatically.</b>';
        } else if (live && withPick === 1) {
          var t2 = tiers.length ? tiers[0] : null;
          noteEl.innerHTML = MAXTXT ? '' : (t2 ? 'Add a second gown to unlock <b>' + rungTxt(t2.pct) + '.</b>' : '');
        } else if (disc > 0) {
          noteEl.innerHTML = MAXTXT ? 'You are saving <b>' + money(disc) + '</b>, automatically.' : 'You are saving <b>' + money(disc) + '</b>, ' + rungTxt(tierPct(withPick)) + ', automatically.';
        } else {
          noteEl.textContent = '';
        }
        if (CREDIT) noteEl.textContent = disc > 0 ? 'Arrives when your order ships. Use it on your next order.' : '';
      }

      addBtn.disabled = !avail;
      addBtn.textContent = avail ? addLabel + ' · ' + money(m.price) : (product ? 'That combination is sold out' : addLabel);

      if (stateEl) {
        if (justAdded && cartCount > 0) {
          var nx = null;
          for (var k = 0; k < tiers.length; k++) { if (tiers[k].q > cartCount) { nx = tiers[k]; break; } }
          var nd = nx ? nx.q - cartCount : 0;
          stateEl.textContent = nx ? (MAXTXT ? 'Added.' : 'Added. ' + (nd === 1 ? 'One more gown' : nd + ' more gowns') + ' unlocks ' + rungTxt(nx.pct) + '.')
                                   : (CREDIT ? 'Added.' : 'Added. Maximum savings unlocked.');
        }
        else if (cartCount === 0 && !live) stateEl.textContent = 'Pick a gown to start.';
        else if (cartCount === 0) stateEl.textContent = MAXTXT ? 'One gown picked.' : 'Nightgown savings start at two.';
        else stateEl.textContent = cartCount + (cartCount === 1 ? ' gown' : ' gowns') + ' in your cart' + (live ? ', one picked.' : '.');
      }

      tiers.forEach(function (t) {
        t.el.classList.remove('is-won', 'is-next', 'is-far');
        if (t.q <= cartCount) t.el.classList.add('is-won');
        else if (t.q <= withPick) t.el.classList.add('is-next');
        else if (t.q > withPick + 1) t.el.classList.add('is-far');
      });
      if (progEl && maxQ) progEl.style.width = Math.min(100, Math.round(withPick / maxQ * 100)) + '%';
      if (mileEl) {
        var next = null;
        for (var i = 0; i < tiers.length; i++) { if (tiers[i].q > withPick) { next = tiers[i]; break; } }
        if (MAXTXT && next) mileEl.textContent = MAXTXT;
        else if (withPick === 0) mileEl.textContent = 'Savings start at two gowns.';
        else if (next) {
          var need = next.q - withPick;
          mileEl.innerHTML = (need === 1 ? 'One more gown' : need + ' more gowns') + ' makes it <b>' + rungTxt(next.pct) + '.</b>';
        } else {
          mileEl.innerHTML = CREDIT ? 'You reached the top reward: <b>$' + tierPct(withPick) + '</b> in store credit for each gown.'
            : 'Maximum saving unlocked: <b>' + rungTxt(tierPct(withPick)) + ', ' + money(tierAmt(withPick)) + '.</b>';
        }
      }
    }

    function refreshCart() {
      return fetch(u('/cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (c) {
          var before = cartCount;
          cartLines = (c.items || []).filter(function (it) { return handles.indexOf(it.handle) > -1; });
          cartCount = 0;
          cartLines.forEach(function (it) { cartCount += it.quantity; });
          if (pendingAdded) { lastAdded = pendingAdded; pendingAdded = null; }
          else if (cartCount < before) lastAdded = null;   /* gowns left the cart: the pick is a fresh pick again */
          learnCartStyles();
          paintRail();
        })
        .catch(function () {});
    }

    function loadStyle(handle) {
      if (cache[handle]) {
        product = cache[handle];
        var f = null;
        for (var i = 0; i < product.variants.length; i++) { if (product.variants[i].available) { f = product.variants[i]; break; } }
        sel = ((f || product.variants[0]).options || []).slice();
        paintOptions(); paintMedia(); paintBenefits(); paintRail();
        return;
      }
      fetch(u('/products/' + handle + '.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          cache[handle] = p;
          if (styleSel.value === handle) loadStyle(handle);
        })
        .catch(function () { if (errEl) { errEl.textContent = 'Could not load that style. Please try again.'; } });
    }

    styleSel.addEventListener('change', function () {
      if (errEl) errEl.textContent = '';
      if (styleSel.value) loadStyle(styleSel.value);
    });

    addBtn.addEventListener('click', function () {
      var m = match();
      if (!m || !m.available) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      if (errEl) errEl.textContent = '';
      var prevCount = cartCount;
      fetch(u('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: m.id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () {
          if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (addedEl) {
            addedEl.classList.add('is-shown');
            setTimeout(function () { addedEl.classList.remove('is-shown'); }, 3500);
          }
          if (tidy) pendingAdded = m.id;   /* becomes lastAdded once the cart read lands, so the rail never blinks empty */
          var done = refreshCart();
          if (done && done.then) done.then(function () { celebrate(prevCount); });
          setTimeout(function () { paintRail(); }, 50);
        })
        .catch(function () {
          if (errEl) errEl.textContent = 'Could not add to cart. Please try again.';
          paintRail();
        });
    });

    document.addEventListener('cart:updated', refreshCart);

    if (handles.length) {
      styleSel.value = handles[0];
      loadStyle(handles[0]);
    }
    refreshCart();
  }

  var CSS = '.bys__gben{margin-top:22px;border-radius:12px;padding:16px 18px;color:var(--gben,#2c3d54);background:#eef1f5;background:color-mix(in srgb,var(--gben,#2c3d54) 11%,#fff)}' +
    '.bys__gben-h{display:flex;align-items:baseline;flex-wrap:wrap;gap:4px 10px}.bys__gben-h b{font-family:Georgia,serif;font-weight:400;font-size:19px}.bys__gben-h span{font-size:12.5px;opacity:.8}' +
    '.bys__gben ul{list-style:none;margin:10px 0 0;padding:0;display:flex;flex-wrap:wrap;gap:6px 16px}.bys__gben li{margin:0;font-size:13.5px;font-weight:600;line-height:1.3}' +
    '.bys__gben li::before{content:"\\2713";display:inline-block;width:16px;height:16px;margin-right:6px;border-radius:50%;background:var(--gben,#2c3d54);color:#fff;font-size:10px;line-height:16px;text-align:center;font-family:Arial,sans-serif}' +
    '.bys__gben-f{margin-top:10px;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}' +
    '[data-gp-tidy] .bys__tier{position:relative}.bys__gspark{position:absolute;left:50%;top:50%;width:0;height:0;pointer-events:none;z-index:3}' +
    '.bys__gspark i{position:absolute;left:-3px;top:-3px;width:6px;height:6px;border-radius:50%;opacity:0}' +
    '@media (prefers-reduced-motion: no-preference){' +
      '.bys__tier.is-hit{animation:gpHit .9s cubic-bezier(.2,1.4,.4,1) 1;z-index:2}' +
      '.bys__tier.is-nudge{animation:gpNudge .9s ease 1}' +
      '.bys__gspark i{animation:gpSpark .8s ease-out forwards}' +
      '@keyframes gpHit{0%{transform:scale(1);box-shadow:0 0 0 0 rgba(236,164,158,.9)}30%{transform:scale(1.14) rotate(-2deg)}55%{transform:scale(.97) rotate(1deg)}75%{transform:scale(1.04)}100%{transform:scale(1);box-shadow:0 0 0 16px rgba(236,164,158,0)}}' +
      '@keyframes gpNudge{0%,100%{transform:translateY(0);box-shadow:0 0 0 1px #fff}25%{transform:translateY(-5px);box-shadow:0 0 0 3px #fff,0 6px 14px rgba(0,0,0,.25)}50%{transform:translateY(0)}70%{transform:translateY(-2px)}}' +
      '@keyframes gpSpark{0%{transform:translate(0,0) scale(1);opacity:1}100%{transform:translate(var(--dx),var(--dy)) scale(.3);opacity:0}}' +
    '}';
  function boot() {
    if (!document.querySelector('style[data-gp-css]') && document.querySelector('[data-gp-tidy], [data-gp-benefits]')) {
      var st = document.createElement('style'); st.setAttribute('data-gp-css', ''); st.textContent = CSS; document.head.appendChild(st);
    }
    [].slice.call(document.querySelectorAll('[data-bys-gownpick]')).forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
